const locale = {
  id: 'AnnouncementConstant',
  code: 'CN',
  text: {
    "./images/Announcement_en@2x.png": "./images/Announcement.png",
    'Automatic Mailing (to students) and SMS (to teachers) Announcement System': '自动发邮件（针对学员）与短信（针对老师）的公告系统',
    'Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers': '在这里您可以创建针对全体老师和学生的公告，也可针对指定班级发布公告。在您创建的公告发布的时候，系统会自动将公告内容给学生发邮件、给老师发手机短信。',
  }
}

export const onBoardingContents = {
  // we show this when student state is 'current'
  all: {
    title: __('Automatic Mailing (to students) and SMS (to teachers) Announcement System', locale),
    text: __('Here you can create announcements for all teachers and students, as well as specific classes. When the announcement is published, the system will automatically send the announcement via email to students and SMS to teachers', locale),
    image: require(__('./images/Announcement_en@2x.png', locale)),
    showArrow: true,
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/constant.js